'use client'

import { toastError } from '@/utils/toaster'
import { useRouter } from 'next/navigation'
import React, { useEffect, useState } from 'react'

function JoinOurTeam() {
   const [data, setData] = useState([])
   const [loading, setLoading] = useState(true)
   const router = useRouter()

   useEffect(() => {
      const fetchJobs = async () => {
         try {
            const response = await fetch(
               `${process.env.NEXT_PUBLIC_BACKEND_URL}/careers`
            )

            if (!response.ok) {
               if (response.status === 429) {
                  toastError('Too many requests. Please try again later.')
                  return
               }
               throw new Error(`HTTP error! status: ${response.status}`)
            }

            const result = await response.json()

            if (result?.msg === 'All Careers' && Array.isArray(result?.data)) {
               setData(result.data)
            } else {
               throw new Error('Invalid data format received')
            }
         } catch (error) {
            // console.error('Error fetching careers:', error)
            toastError('Failed to load career opportunities. Please try again.')
            setData([])
         } finally {
            setLoading(false)
         }
      }

      fetchJobs()
   }, [])
   return (
      <section className="section_secondary_bg" id="join-team">
         <div className="container text-center">
            <p className="intro_description" style={{ fontWeight: '500' }}>
               JOIN OUR TEAM
            </p>
            <h2 className="section_heading_title mb-3 tech_title">
               Discover Career Opportunities
            </h2>
            <p className="intro_description">
               Join Benzatine Infotech and take your career to new heights!
               We're building our team and want enthusiastic professionals ready
               to <br />
               innovate and develop. Let's create the future together if you're
               driven, capable, and ready to break barriers
               <br />
               Have something else in mind? Tell us about it at
               <span
                  className="text-decoration-underline"
                  style={{ fontWeight: '500' }}
               >
                  <a className="cs-text-primary" href="mailto:hr@benzatine.com">
                     {' '}
                     hr@benzatine.com
                  </a>
               </span>
            </p>

            <div className="discovery_job_opening mt-5" id="job-list">
               {loading ? (
                  <div className="text-center">Loading...</div>
               ) : data?.length === 0 ? (
                  <div className="text-center">
                     No job openings available at the moment.
                  </div>
               ) : (
                  data?.map((job) => {
                     return (
                        <div
                           className="job-card position-relative"
                           key={job.id}
                        >
                           <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 gap-md-3">
                              <h3 className="job-title">
                                 {job.title}{' '}
                                 {job.label === 'URGENT' ? (
                                    <span className="badge bg-danger job-tag">
                                       {job.label}
                                    </span>
                                 ) : (
                                    ''
                                 )}
                              </h3>
                              <div className="d-flex align-items-center flex-wrap gap-4">
                                 <div className="job-info">
                                    <svg
                                       width="43"
                                       height="45"
                                       viewBox="0 0 43 45"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path
                                          d="M18.5994 6.17995L9.81705 9.47115C7.79305 10.228 6.13867 12.6216 6.13867 14.7864V27.8631C6.13867 29.9399 7.51149 32.6679 9.18349 33.9175L16.7515 39.5671C19.2331 41.4327 23.3162 41.4327 25.7978 39.5671L33.3659 33.9175C35.0379 32.6679 36.4106 29.9399 36.4106 27.8631V14.7864C36.4106 12.6216 34.7562 10.228 32.7322 9.47115L23.9499 6.17995C22.4539 5.63435 20.0602 5.63435 18.5994 6.17995Z"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M21.2568 29.5353C25.1448 29.5353 28.2968 26.3835 28.2968 22.4953C28.2968 18.6073 25.1448 15.4553 21.2568 15.4553C17.3687 15.4553 14.2168 18.6073 14.2168 22.4953C14.2168 26.3835 17.3687 29.5353 21.2568 29.5353Z"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeMiterlimit="10"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M21.6961 20.2952V21.932C21.6961 22.548 21.3793 23.1288 20.8337 23.4456L19.4961 24.2552"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeMiterlimit="10"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                    </svg>
                                    <div className="text-start">
                                       <h6 className="m-0">{job.experience}</h6>
                                       <p className="m-0">Experience</p>
                                    </div>
                                 </div>
                                 <div className="job-info">
                                    <svg
                                       width="43"
                                       height="45"
                                       viewBox="0 0 43 45"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path
                                          d="M16.2581 21.3863C16.0821 21.3687 15.8709 21.3687 15.6773 21.3863C11.4885 21.2455 8.16211 17.8135 8.16211 13.5895C8.16211 9.27755 11.6469 5.77515 15.9765 5.77515C20.2886 5.77515 23.791 9.27755 23.791 13.5895C23.7734 17.8135 20.447 21.2455 16.2581 21.3863Z"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M29.0198 9.29517C32.4342 9.29517 35.1798 12.0584 35.1798 15.4552C35.1798 18.7815 32.5398 21.4919 29.2486 21.6151C29.1078 21.5975 28.9494 21.5975 28.791 21.6151"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M7.45807 27.8809C3.19887 30.7321 3.19887 35.3785 7.45807 38.2121C12.2981 41.4505 20.2356 41.4505 25.0756 38.2121C29.3348 35.3609 29.3348 30.7145 25.0756 27.8809C20.2532 24.6601 12.3157 24.6601 7.45807 27.8809Z"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M32.4141 37.4553C33.6813 37.1913 34.8781 36.6809 35.8637 35.9241C38.6093 33.8649 38.6093 30.4681 35.8637 28.4089C34.8957 27.6697 33.7165 27.1769 32.4669 26.8953"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                    </svg>
                                    <div className="text-start">
                                       <h6 className="m-0">
                                          {job.no_of_position}
                                       </h6>
                                       <p className="m-0">Position</p>
                                    </div>
                                 </div>
                                 <div className="job-info">
                                    <svg
                                       width="43"
                                       height="43"
                                       viewBox="0 0 43 43"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path
                                          d="M14.1381 39H28.1381C35.1731 39 36.4331 36.1825 36.8006 32.7525L38.1131 18.7525C38.5856 14.4825 37.3606 11 29.8881 11H12.3881C4.91562 11 3.69062 14.4825 4.16312 18.7525L5.47562 32.7525C5.84312 36.1825 7.10313 39 14.1381 39Z"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeMiterlimit="10"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M14.1367 11V9.6C14.1367 6.5025 14.1367 4 19.7367 4H22.5367C28.1367 4 28.1367 6.5025 28.1367 9.6V11"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeMiterlimit="10"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M24.6367 23.25V25C24.6367 25.0175 24.6367 25.0175 24.6367 25.035C24.6367 26.9425 24.6192 28.5 21.1367 28.5C17.6717 28.5 17.6367 26.96 17.6367 25.0525V23.25C17.6367 21.5 17.6367 21.5 19.3867 21.5H22.8867C24.6367 21.5 24.6367 21.5 24.6367 23.25Z"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeMiterlimit="10"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M38.0242 19.75C33.9817 22.69 29.3617 24.44 24.6367 25.035"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeMiterlimit="10"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M4.72266 20.2188C8.66016 22.9138 13.1052 24.5412 17.6377 25.0487"
                                          stroke="#1F473E"
                                          strokeWidth="2"
                                          strokeMiterlimit="10"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                    </svg>

                                    <div className="text-start">
                                       <h6 className="m-0">Full Time</h6>
                                       <p className="m-0">Job Type</p>
                                    </div>
                                 </div>
                                 <button
                                    className="btn bez-fill-btn job-action-buttons"
                                    onClick={() =>
                                       router.push(
                                          `/discover-benzatine/career-overview/${job.slug}`
                                       )
                                    }
                                 >
                                    view details
                                    <svg
                                       width="25"
                                       height="25"
                                       viewBox="0 0 25 25"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path
                                          d="M14.2011 19.6006C14.0025 19.6018 13.808 19.5437 13.6425 19.4339C13.477 19.3241 13.3479 19.1675 13.2718 18.9841C13.1956 18.8007 13.1758 18.5987 13.2148 18.4039C13.2539 18.2092 13.3501 18.0305 13.4911 17.8906L18.7911 12.6006L13.4911 7.31061C13.3273 7.11931 13.2417 6.87324 13.2514 6.62156C13.2611 6.36988 13.3655 6.13114 13.5436 5.95305C13.7217 5.77496 13.9604 5.67062 14.2121 5.6609C14.4638 5.65118 14.7098 5.73679 14.9011 5.90061L20.9011 11.9006C21.0874 12.088 21.1919 12.3414 21.1919 12.6056C21.1919 12.8698 21.0874 13.1233 20.9011 13.3106L14.9011 19.3106C14.7149 19.4954 14.4635 19.5995 14.2011 19.6006Z"
                                          fill="#F4F2F0"
                                       />
                                       <path
                                          d="M6.19527 19.6017C5.99664 19.6029 5.80218 19.5449 5.63666 19.4351C5.47114 19.3253 5.34206 19.1687 5.2659 18.9852C5.18973 18.8018 5.16992 18.5998 5.20899 18.4051C5.24806 18.2103 5.34424 18.0316 5.48527 17.8918L10.7853 12.6017L5.48527 7.31175C5.29697 7.12344 5.19118 6.86805 5.19118 6.60175C5.19118 6.33545 5.29697 6.08005 5.48527 5.89175C5.67357 5.70344 5.92897 5.59766 6.19527 5.59766C6.46157 5.59766 6.71697 5.70344 6.90527 5.89175L12.9053 11.8917C13.0915 12.0791 13.1961 12.3326 13.1961 12.5967C13.1961 12.8609 13.0915 13.1144 12.9053 13.3017L6.90527 19.3018C6.81265 19.3962 6.70221 19.4714 6.58033 19.5229C6.45846 19.5744 6.32758 19.6012 6.19527 19.6017Z"
                                          fill="#F4F2F0"
                                       />
                                    </svg>
                                 </button>
                              </div>
                           </div>
                        </div>
                     )
                  })
               )}
            </div>
         </div>
      </section>
   )
}

export default JoinOurTeam
